import { useState } from "react";
import { FaPenSquare } from "react-icons/fa";
import { Spacing } from "~/jsx/theme";
import { XTypography } from "./XTypography";

export const XUpdatableInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange?: (value: string) => void;
}) => {
  const [isModified, setModified] = useState(false);
  const [modifiedValue, setModifiedValue] = useState(value);

  const onValidateChange = () => {
    setModified(false);
    onChange?.(modifiedValue);
  };

  if (isModified) {
    return (
      <input
        autoFocus
        value={modifiedValue}
        onChange={(event) => setModifiedValue(event.target.value)}
        onBlur={onValidateChange}
        onKeyDown={(event) => {
          if (event.key.toLowerCase().includes("enter")) {
            onValidateChange();
          }
        }}
      />
    );
  } else {
    return (
      <XTypography>
        {value}
        <FaPenSquare
          style={{
            verticalAlign: "middle",
            marginLeft: Spacing.px4,
            cursor: "pointer",
          }}
          onClick={() => {
            setModifiedValue(value);
            setModified(true);
          }}
        />
      </XTypography>
    );
  }
};
